export default {
  'pages.todo.adminTitle': '待辦管理',
  'pages.todo.consoleTitle': '我的待辦',
  'pages.todo.adminDesc': '檢視與管理全部使用者的待辦事項，支援按使用者 / 關鍵詞 / 狀態過濾。',
  'pages.todo.consoleDesc': '管理歸屬當前賬號的待辦事項。',
  'pages.todo.new': '新建待辦',
  'pages.todo.colTitle': '標題',
  'pages.todo.colContent': '內容',
  'pages.todo.colPriority': '優先順序',
  'pages.todo.colRemindAt': '提醒時間',
  'pages.todo.colRepeatRule': '重複',
  'pages.todo.colStatus': '狀態',
  'pages.todo.colSource': '來源',
  'pages.todo.colUser': '歸屬使用者',
  'pages.todo.colUserIdFilter': '使用者ID',
  'pages.todo.colUsernameFilter': '使用者名稱',
  'pages.todo.colDeviceFilter': '裝置MAC',
  'pages.todo.colDevice': '裝置',
  'pages.todo.colKeyword': '關鍵詞',
  'pages.todo.keywordPlaceholder': '標題或內容關鍵詞',
  'pages.todo.deviceTip': '選擇關聯的裝置，可留空',
  'pages.todo.deviceSelectPlaceholder': '選擇裝置（名稱 / MAC）',
  'pages.todo.noDevice': '未找到裝置',
  'pages.todo.colCreatedAt': '建立時間',
  'pages.todo.colActions': '操作',
  'pages.todo.complete': '完成',
  'pages.todo.edit': '編輯',
  'pages.todo.delete': '刪除',
  'pages.todo.confirmDelete': '確定刪除該待辦？',
  'pages.todo.confirm': '確定',
  'pages.todo.cancel': '取消',
  'pages.todo.created': '建立成功',
  'pages.todo.updated': '更新成功',
  'pages.todo.completed': '已完成',
  'pages.todo.completedRepeat': '已完成本次，下次提醒已順延',
  'pages.todo.deleted': '已刪除',
  'pages.todo.opFail': '操作失敗',
  'pages.todo.titleRequired': '請輸入標題',
  'pages.todo.remindAtPlaceholder': '選擇提醒時間（本地時區）',
  'pages.todo.targetUser': '歸屬使用者',
  'pages.todo.targetUserTip': '留空則歸屬當前登入賬號',
  'pages.todo.userIdPlaceholder': '輸入使用者ID過濾',
  'pages.todo.usernamePlaceholder': '輸入使用者名稱過濾',
  'pages.todo.devicePlaceholder': '輸入裝置MAC過濾',
  'pages.todo.searchUserPlaceholder': '輸入使用者名稱搜尋選擇',
  'pages.todo.noUserFound': '未找到使用者',

  // 優先順序 / 來源 / 重複 / 狀態標籤
  'pages.todo.priority.normal': '普通',
  'pages.todo.priority.important': '重要',
  'pages.todo.priority.urgent': '緊急',
  'pages.todo.source.user': '使用者',
  'pages.todo.source.admin': '管理端',
  'pages.todo.source.device': '裝置',
  'pages.todo.repeat.none': '不重複',
  'pages.todo.repeat.daily': '每天',
  'pages.todo.repeat.weekly': '每週',
  'pages.todo.repeat.monthly': '每月',
  'pages.todo.status.todo': '待辦',
  'pages.todo.status.done': '已完成',
};
